define('cartware_checkout/components/address/restriction',[
	"jquery",
	"lodash",
	"cartware_checkout",
	"cartware/components/_base",
	"text!shoptheme/templates/magnific-popup/default.html",
	"json2",
	"magnific-popup"
], function(
	$,
	_,
	Checkout,
	Component,
	PopupHtml
) {
	var popupTemplate = null,
		messageTemplate = null;

	var messageHtml;

	return Component.create({
		$init: function() {
            messageHtml = '<div class="b_qaddress-validation-result">' +
                '<div class="b_qaddress-validation-result__message">' +
                '<%= message %>' +
                '</div>' +
                '<div class="b_qaddress-validation-result__buttons">' +
                '<button class="btn btn-primary b_qaddress-validation-result__button b_qaddress-validation-result__button--accept" data-mfp-close>' +
                    Translator.translate("OK") +
                '</button>' +
                '</div>' +
                '</div>';

			this._adviseShipping();
			this._adviseBilling();
		},

		_adviseShipping: function() {
			this._setupAdvise("shipping");
		},

		_adviseBilling: function() {
			this._setupAdvise("billing");
		},

		_setupAdvise: function(type) {
			var self = this;

			Checkout().retrieve(type, function(obj) {
				var onSave = obj.onSave;
				obj.onSave = function(transport) {
					var response = JSON.parse(transport.responseText);

					if (response.error && response.restricted) {
						$.magnificPopup.open({
							items: {
								src: self._renderPopup({
									title: Translator.translate('Address validation'),
									body: self._renderMessage({	
										message: response.message,
									})
								}),
								type: 'inline'
							},

							callbacks: {
								open: function() {
									var self = this;
									this.content.on("click", "[data-mfp-close]", function() {
										self.close();
									});
								},
							}
						});

						return;
					}

					return onSave.apply(this, arguments);
				}
			});
		},

		_renderPopup: function(data) {
			if (null === popupTemplate) {
				popupTemplate = _.template(PopupHtml);
			}

			return popupTemplate(data);
		},

		_renderMessage: function(data) {
			if (null === messageTemplate) {
				messageTemplate = _.template(messageHtml);
			}

			return messageTemplate(data);
		}
	});
});
